import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./LoginSuccessPage.css";
import { toast } from "wc-toast";
import { useAuth } from "../UserProvider";

interface LoginSuccessPageProps {}

export const LoginSuccessPage: React.FC<LoginSuccessPageProps> = () => {
    const { hash } = useLocation();
    const navigate = useNavigate();
    const { user, login } = useAuth();

    useEffect(() => {
        const token = hash.split("=")[1];

        if (token && user?.token !== token) {
            login(token);
            toast.success("Authentication success");
            navigate("/");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="page-login-success">
            <img className="logo" alt="logo" src="/game/logo.svg"></img>
            <h1>Welcome!</h1>

            <a href="/game/play">
                <b>Play →</b>
            </a>
            {user && (
                <>
                    <hr />
                    <small>Your user id is: {user.id}</small>
                </>
            )}
        </div>
    );
};
